import React from "react"
import { useAuthContext } from "../../Hooks/useAuthContext"

import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Logo Image
import Logo from "../../Images/logo.png"

export default function TopNav({  }) {
  const { user, dispatch } = useAuthContext()
  const navigate = useNavigate()



  return (
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" sticky="top">
      <Container className="container-fluid">
        <NavLink to="/" className="navbar-brand">
            <img src={Logo} style={{ height: 50, marginRight: 50 }} />
        </NavLink>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          {user && (
            <>
              <Nav className="me-auto">

                
                <NavLink className="nav-link" to="/Customers">
                    Customers
                </NavLink>
                <NavLink className="nav-link" to="/Suppliers">
                    Suppliers
                </NavLink>
                <NavLink className="nav-link" to="/Products">
                    Products
                </NavLink>
                <NavLink className="nav-link" to="/Orders">
                    Orders
                </NavLink>
                {user.role == "Admin" && (
                    <>
                        <NavLink className="nav-link" to="/Users">
                            Users / Agents
                        </NavLink>
                        <NavLink className="nav-link" to="/Reports">
                            Reports
                        </NavLink>
                    </>
                )}
              </Nav>
              <Nav>
                <Nav.Link
                  onClick={() => {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                  }}
                >
                  Log Out
                </Nav.Link>
                              <NavLink className="nav-link" to={"/Users/View/" + user.id }>
                  {user.name}
                </NavLink>
                
              </Nav>
            </>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
